// Generated from /Volumes/Data/Code/Cobham/neko-paie/backend/formula/src/main/antlr/com/cobhamsolutions/nekopaie/formula/parser/Formula.g4 by ANTLR 4.13.2
// jshint ignore: start
import antlr4 from 'antlr4';

// This class defines a complete listener for a parse tree produced by FormulaParser.
export default class FormulaListener extends antlr4.tree.ParseTreeListener {

	// Enter a parse tree produced by FormulaParser#calculable.
	enterCalculable(ctx) {
	}

	// Exit a parse tree produced by FormulaParser#calculable.
	exitCalculable(ctx) {
	}


	// Enter a parse tree produced by FormulaParser#condition.
	enterCondition(ctx) {
	}

	// Exit a parse tree produced by FormulaParser#condition.
	exitCondition(ctx) {
	}


	// Enter a parse tree produced by FormulaParser#comparison.
	enterComparison(ctx) {
	}

	// Exit a parse tree produced by FormulaParser#comparison.
	exitComparison(ctx) {
	}


	// Enter a parse tree produced by FormulaParser#comparator.
	enterComparator(ctx) {
	}

	// Exit a parse tree produced by FormulaParser#comparator.
	exitComparator(ctx) {
	}


	// Enter a parse tree produced by FormulaParser#operation.
	enterOperation(ctx) {
	}

	// Exit a parse tree produced by FormulaParser#operation.
	exitOperation(ctx) {
	}


	// Enter a parse tree produced by FormulaParser#expression.
	enterExpression(ctx) {
	}

	// Exit a parse tree produced by FormulaParser#expression.
	exitExpression(ctx) {
	}


	// Enter a parse tree produced by FormulaParser#variablePart.
	enterVariablePart(ctx) {
	}

	// Exit a parse tree produced by FormulaParser#variablePart.
	exitVariablePart(ctx) {
	}


	// Enter a parse tree produced by FormulaParser#variable.
	enterVariable(ctx) {
	}

	// Exit a parse tree produced by FormulaParser#variable.
	exitVariable(ctx) {
	}


	// Enter a parse tree produced by FormulaParser#constant.
	enterConstant(ctx) {
	}

	// Exit a parse tree produced by FormulaParser#constant.
	exitConstant(ctx) {
	}


	// Enter a parse tree produced by FormulaParser#function.
	enterFunction(ctx) {
	}

	// Exit a parse tree produced by FormulaParser#function.
	exitFunction(ctx) {
	}


	// Enter a parse tree produced by FormulaParser#arg.
	enterArg(ctx) {
	}

	// Exit a parse tree produced by FormulaParser#arg.
	exitArg(ctx) {
	}


	// Enter a parse tree produced by FormulaParser#argsList.
	enterArgsList(ctx) {
	}

	// Exit a parse tree produced by FormulaParser#argsList.
	exitArgsList(ctx) {
	}



}